// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gauge-icon[data-v-414591ea]{display:inline}.row-title[data-v-414591ea]{align-self:center;font-size:20px}@media (min-width:600px){.row-title[data-v-414591ea]{font-size:1.5rem!important}}", ""]);
// Exports
module.exports = exports;
